// useGlobalSync.js

import { globalLockManager } from "global/globalLock"
import { useEffect } from "react"
import { useIndexedDB } from "./useIndexedDB"
import useSyncBlobs from "./useSyncBlobs"

export function useGlobalSync({ databaseName, pollInterval, finalApiCall }) {
  const { getAllDataFromStore } = useIndexedDB("audioDB", "audio", null, true, [{ storeName: "processedAudio" }])
  const { syncData } = useSyncBlobs({
    finalUploadQuery: finalApiCall,
    deleteOnFail: false,
  })

  let intervalId = null

  useEffect(() => {
    const sync = async () => {
      if (globalLockManager.isLocked("audio")) {
        return
      }

      const uploadIdData = await getAllDataFromStore(null, "audioMetadata")

      if (!uploadIdData?.[0]?.isFinished) return
      else {
        try {
          globalLockManager.lock("audio")
          await syncData(false)
        } catch (err) {
          globalLockManager.unlock("audio")
        }
      }
    }

    intervalId = setInterval(sync, pollInterval)
    sync() // Initial run

    return () => clearInterval(intervalId)
  }, [pollInterval])
}
